export enum AboutStepInputNames {
  RecipientType = 'recipientType',
  Email = 'emailAddress',
}
